import React from "react";
import "./App.css";
import Clock from "./Clock";

function App() {
  return (
    <div className="App">
      <div className="App-header">
        <Clock />
      </div>
    </div>
  );
}

export default App;
